
export default {
  selection: true,
  reserveSelection:true,
    menu: true,
    border: 'true',
    menuAlign: "center",
    menuType: "button",
    // border:true,
    // excelBtn:true,
    height: "auto",
    calcHeight:90,
    indexLabel: '#',
    index:true,
    addBtn:false,
    delBtn:false,
    searchBtn:false,
    emptyBtn:false,
    refreshBtn:true,
    // header:false,
    editBtn:false,
    // align: "center",
    // columnBtn:false,
    menuWidth:150,
    column: [
      {
        showColumn:true,
        "label": "服务单号",
        width:'160',
        "prop": "code",
      },
      {
        showColumn:true,
        "label": "服务单状态",
        "prop": "workStatus",
        width:'100',
        searchSpan:24,
        "type": "select",
        dataType:'string',
        slot:true,
        // searchslot:true,
        props:{
          label:'dictValue',
          value:'dictKey'
        },
        // dicUrl:'/api/blade-system/dict/dictionary?code=out_order_work_status'
      },
      {
        showColumn:true,
        label: "服务类型",
        width:'120',
        prop: "moduleType",
          props:{
              label:'dictValue',
              value:'dictKey'
            },
            dicUrl:'/api/blade-system/dict/dictionary?code=out_order_module_type'
      },
      {
        showColumn:true,
        "label": "服务项目",
        width:'120',
        "prop": "serviceItemName",
      },
      {
        showColumn:true,
        label: "下单方式",
        width:'120',
        prop: "source",
          props:{
              label:'dictValue',
              value:'dictKey'
            },
            dicUrl:'/api/blade-system/dict/dictionary?code=order_require_source'
      },
      {
        showColumn:true,
        sortable:true,
        "label": "下单时间",
        "prop": "createTime",
        width:'140',
        "type": "input"
      },
      {
        showColumn:true,
        "label": "需求人",
        "prop": "contactName",
        "type": "input"
      },
      {
        showColumn:true,
        "label": "联系电话",
        "prop": "contactPhone",
        width:'100',
        "type": "input"
      },
      {
        showColumn:true,
        "label": "期望服务时间",
        "prop": "expectStartTime",
        width:'180',
        "type": "datetime"
      },
      {
        showColumn:true,
        "label": "紧急程度",
        "prop": "urgentLevel",
        slot:true,
        "type": "input"
      },
      {
        "label": "需求描述",
        "prop": "description",
        width:'200',
        slot:true,
        showColumn:true,
      },
      {
        showColumn:true,
        "label": "所属小区/网点",
        width:'140',
        "prop": "communityName",
        "type": "tree",
      },
      {
        showColumn:true,
        "label": "详细地址",
        width:'200',
        "prop": "contactAddress",
        "type": "tree",
        slot:true,
        // slot:true,
      },
      {
        label:"服务商",
        prop:"serviceProviderName",
        width:'180',
        showColumn:true,
      },
      {
        showColumn:true,
        "label": "服务人员",
        "prop": "handerName",
        "type": "input",
        width:'100',
      },
      // {
      //   label:"接单时间",
      //   prop:"accpetTime",
      //   width:'140',
      //   showColumn:true,
      // },
      // {
      //   label:"派单时间",
      //   prop:"appointTime",
      //   width:'140',
      //   showColumn:true,
      // },
      {
        label:"实际上门服务时间",
        prop:"startTime",
        width:'140',
        showColumn:true,
      },
      {
        label:"服务完成时间",
        prop:"endTime",
        width:'140',
        showColumn:true,
      },
      {
        label:"订单金额",
        prop:"totalAmount",
        showColumn:true,
      },
      {
        label:"评价综合分数",
        prop:"avgRating",
        width:'120',
        showColumn:true,
      },
      {
        label:"工单评价",
        prop:"qualifyFlag",
        showColumn:true,
        dicData: [
          {
            label: '不合格',
            value: 0,
          },
          {
            label: '合格',
            value: 1,
          },
        ],
      },
      {
        label:"回访满意度",
        prop:"satisfaction",
        showColumn:true,
        width:'120',

          props:{
            label:'dictValue',
            value:'dictKey'
          },
          dicUrl:'/api/blade-system/dict/dictionary?code=return_visit_satisfaction'
      },

      // {
      //   label:"到场时效",
      //   prop:"appearAging",
      //   showColumn:true,
      // },
      // {
      //   showColumn:true,
      //   "label": "服务得分",
      //   width:'80',
      //   "prop": "serviceItemScore",
      // },
      // {
      //   label:"评价结果",
      //   prop:"serviceEvaluateScore",
      //   showColumn:true,
      // },
      // {
      //   showColumn:true,
      //   "label": "超时时长",
      //   "prop": "timeOut",
      // },
      // {
      //   label:"服务班组",
      //   prop:"groupName",
      //   showColumn:true,
      // },
      // {
      //   label:"协同人",
      //   prop:"cooperateUserNames",
      //   showColumn:true,
      // },
      // {
      //   label:"工作时长",
      //   prop:"workTime",
      //   showColumn:true,
      // },
      // {
      //   label:"耗材",
      //   prop:"consumableName",
      //   showColumn:true,
      // },
      // {
      //   label:"耗材费用",
      //   prop:"amount",
      //   align:"right",
      //   slot:true,
      //   showColumn:true,
      // },

      // {
      //   label:"验收人",
      //   prop:"checkName",
      //   showColumn:true,
      // },
      // {
      //   label:"验收时间",
      //   prop:"checkTime",
      //   showColumn:true,
      // },
      // {
      //   label:"评价人",
      //   prop:"evaluateName",
      //   showColumn:true,
      // },
      // {
      //   label:"评价时间",
      //   prop:"evaluateTime",
      //   showColumn:true,
      // },

      // {
      //   label:"评价内容",
      //   prop:"evaluateContent",
      //   showColumn:true,
      // },

      // {
      //   // showColumn:true,
      //   "label": "需求地点",
      //   prop: "areaId",
      //   searchslot:true,
      //   hide:true,
      //   "type": "tree",
      //   showColumn:false,
      // },





      // {
      //   showColumn:false,
      //   "label": "是否超时",
      //   "prop": "timeoutFlag",
      //   dataType: 'number',
      //   slot:true,
      //   props:{
      //     label:'dictValue',
      //     value:'dictKey'
      //   },
      //   dicUrl:'/api/blade-system/dict/dictionary?code=common_flag'
      // },
      // {

      //   // "label": " ",
      //   width:'160',
      //   searchSpan:24,
      //   hide:true,
      //   searchslot:true,
      //   "prop": "searchContainer",
      //   showColumn:false,
      // },
      // {
      //   "label": "状态",
      //   "prop": "prop10Copy",
      //   hide:true,
      //   "type": "select",
      //   showColumn:false,
      // },

    ]
  }
